(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    const root = document.querySelector('.ncm-custom-page[data-configurator]');
    if (!root) return;

    const form = root.querySelector('#CustomOrderForm');
    const preview = root.querySelector('[data-preview]');
    const stoneChoices = [...root.querySelectorAll('input[name="contact[Material]"]')];
    const unitButtons = [...root.querySelectorAll('[data-unit]')];
    const dimensions = [...root.querySelectorAll('[data-dimension]')];
    const rangeInputs = [...root.querySelectorAll('[data-range-for]')];
    const widthInput = root.querySelector('[data-dimension="width"]');
    const depthInput = root.querySelector('[data-dimension="depth"]');
    const heightInput = root.querySelector('[data-dimension="height"]');
    const backsplashInput = root.querySelector('[data-dimension="backsplash"]');
    const backsplash = root.querySelector('[data-backsplash]');
    const backsplashOptions = root.querySelector('[data-backsplash-options]');
    const backsplashStyles = [...root.querySelectorAll('[data-backsplash-style]')];
    const bowl = root.querySelector('[data-bowl]');
    const finish = root.querySelector('[data-finish]');
    const faucetLocation = root.querySelector('[data-faucet-location]');
    const faucetHoles = root.querySelector('[data-faucet-holes]');
    const faucetSettings = root.querySelector('[data-faucet-settings]');
    const spreadControl = root.querySelector('[data-spread-control]');
    const previewBacksplashes = [...root.querySelectorAll('[data-preview-backsplash]')];
    const previewFlutes = root.querySelector('[data-preview-flutes]');
    const printButton = root.querySelector('[data-print-spec]');
    const cartButton = root.querySelector('[data-add-to-cart]');
    const cartSubtext = root.querySelector('[data-cart-subtext]');
    const whatsappOrderBtn = root.querySelector('[data-whatsapp-order]');
    const oversizeNotice = root.querySelector('[data-oversize-notice]');
    const stonePatternImage = root.querySelector('#ncmStonePatternImage');
    let stoneUrlMap = {};
    try {
      const stoneJson = document.getElementById('ncmStoneUrls');
      if (stoneJson) stoneUrlMap = JSON.parse(stoneJson.textContent);
    } catch (e) {}
    const cartMessage = root.querySelector('[data-cart-message]');
    const configuratorVariant = root.querySelector('[data-configurator-variant]');
    const drawingBacksplash = root.querySelector('[data-drawing-backsplash]');
    const drawingBacksplashInner = root.querySelector('[data-drawing-backsplash-inner]');
    const drawingBowl = root.querySelector('[data-drawing-bowl]');
    const drawingFaucet = root.querySelector('[data-drawing-faucet]');
    const planFaucetDimension = root.querySelector('[data-plan-faucet-dimension]');
    const frontFaucet = root.querySelector('[data-front-faucet]');
    const frontFaucetDimension = root.querySelector('[data-front-faucet-dimension]');
    const planBody = root.querySelector('[data-plan-body]');
    const planInner = root.querySelector('[data-plan-inner]');
    const planDrain = root.querySelector('[data-plan-drain]');
    const planWidthDimension = root.querySelector('[data-plan-width-dimension]');
    const planDepthDimension = root.querySelector('[data-plan-depth-dimension]');
    const frontBody = root.querySelector('[data-front-body]');
    const frontHeightDimension = root.querySelector('[data-front-height-dimension]');
    const backsplashDimension = root.querySelector('[data-backsplash-dimension]');
    const sideWall = root.querySelector('[data-side-wall]');
    const sideBacksplash = root.querySelector('[data-preview-backsplash]');
    const sideBody = root.querySelector('[data-side-body]');
    const sideFlutes = root.querySelector('[data-side-flutes]');
    const sideDepthDimension = root.querySelector('[data-side-depth-dimension]');
    const sideNotes = root.querySelector('[data-side-notes]');
    const faucetSpread = root.querySelector('[data-detail="faucet-spread"]');
    const resetUniversalBtn = root.querySelector('[data-reset-universal]');
    const universalBtnText = root.querySelector('[data-universal-btn-text]');
    const leftShelf = root.querySelector('[data-detail="left-shelf"]');
    const rightShelf = root.querySelector('[data-detail="right-shelf"]');
    const backShelf = root.querySelector('[data-detail="back-shelf"]');
    const frontShelf = root.querySelector('[data-detail="front-shelf"]');
    const leftShelfDimension = root.querySelector('[data-left-shelf-dimension]');
    const rightShelfDimension = root.querySelector('[data-right-shelf-dimension]');
    const backShelfDimension = root.querySelector('[data-back-shelf-dimension]');
    const frontShelfDimension = root.querySelector('[data-front-shelf-dimension]');
    const cornerStyle = root.querySelector('[data-detail="corner"]');
    const surfaceOffset = root.querySelector('[data-detail="offset"]');
    const backsplashOffset = root.querySelector('[data-detail="backsplash-offset"]');
    let unit = 'in';
    let currentPrice = 0;

    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    const checked = (name) => root.querySelector(`input[name="${name}"]:checked`);
    const val = (input) => Number.parseFloat(input?.value) || 0;
    const inches = (input) => unit === 'cm' ? val(input) / 2.54 : val(input);
    const displayValue = (input) => round(val(input), 1);

    function round(number, precision) {
      const factor = 10 ** precision;
      return Math.round(number * factor) / factor;
    }

    function setText(selector, value) {
      const node = root.querySelector(selector);
      if (node) node.textContent = value;
    }

    function setAttributes(node, attributes) {
      if (!node) return;
      Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, round(value, 2)));
    }

    function setHidden(node, hidden) {
      if (!node) return;
      if (node instanceof SVGElement) {
        if (hidden) node.setAttribute('hidden', '');
        else node.removeAttribute('hidden');
        return;
      }
      node.hidden = hidden;
    }

    function setLine(line, x1, y1, x2, y2) {
      setAttributes(line, { x1, y1, x2, y2 });
    }

    function clamp(number, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, number));
    }

    function selectedBacksplashStyle() {
      return backsplashStyles.find((input) => input.checked) || backsplashStyles[0];
    }

    function updateFaucetDrawing(group, dimension, centerX, centerY, visible, holeCount, spreadInches, spreadPx) {
      if (!group) return;
      setHidden(group, !visible);
      const circles = [...group.querySelectorAll('circle')];
      const positions = [centerX - spreadPx / 2, centerX, centerX + spreadPx / 2];
      circles.forEach((circle, index) => {
        setAttributes(circle, { cx: positions[index], cy: centerY, r: 5 });
        circle.style.display = holeCount === 1
          ? (index === 1 ? '' : 'none')
          : holeCount === 2
            ? (index === 0 ? 'none' : '')
            : '';
      });

      if (!dimension) return;
      const showDimension = visible && holeCount > 1;
      setHidden(dimension, !showDimension);
      if (!showDimension) return;
      const dimensionStartX = holeCount === 2 ? centerX : centerX - spreadPx / 2;
      const dimensionEndX = centerX + spreadPx / 2;
      const dimensionY = centerY - 14;
      const lines = dimension.querySelectorAll('line');
      const text = dimension.querySelector('text');
      setLine(lines[0], dimensionStartX, dimensionY, dimensionEndX, dimensionY);
      setLine(lines[1], dimensionStartX, dimensionY - 4, dimensionStartX, dimensionY + 4);
      setLine(lines[2], dimensionEndX, dimensionY - 4, dimensionEndX, dimensionY + 4);
      setAttributes(text, { x: (dimensionStartX + dimensionEndX) / 2, y: dimensionY - 6 });
      const rawSpreadCm = spreadInches * 2.54;
      const displaySpread = unit === 'cm' ? (Math.abs(rawSpreadCm - Math.round(rawSpreadCm)) < 0.05 ? Math.round(rawSpreadCm) : round(rawSpreadCm, 1)) : round(spreadInches, 1);
      const displayHalfSpread = unit === 'cm' ? round((rawSpreadCm / 2), 1) : round(spreadInches / 2, 1);
      text.textContent = `${holeCount === 2 ? displayHalfSpread : displaySpread}${unit === 'cm' ? ' cm' : '"'} C-C`;
    }

    function updateBacksplashDrawing(geometry) {
      if (!drawingBacksplash) return;
      const paths = {
        straight: 'M250 505V435H550V505Z',
        rounded: 'M250 505V450Q250 435 265 435H535Q550 435 550 450V505Z',
        'big-radius': 'M250 505V465Q250 435 280 435H520Q550 435 550 465V505Z',
        'gentle-arch': 'M250 505V455Q400 415 550 455V505Z',
        shouldered: 'M250 505V465H280Q280 430 320 430H480Q520 430 520 465H550V505Z',
        'wide-shoulder': 'M250 505V465H270Q270 420 320 420H480Q530 420 530 465H550V505Z',
        'standard-ogee': 'M250 505V465Q300 465 340 430Q380 395 400 395Q420 395 460 430Q500 465 550 465V505Z',
        'double-ogee': 'M250 505V465Q290 465 315 445Q340 425 400 425Q460 425 485 445Q510 465 550 465V505Z',
        'tall-ogee': 'M250 505V470Q290 470 320 435Q350 395 400 395Q450 395 480 435Q510 470 550 470V505Z',
        'cove-bead': 'M250 505V450Q275 450 275 430Q275 410 300 410H500Q525 410 525 430Q525 450 550 450V505Z',
        french: 'M250 505V450Q325 450 365 410H435Q475 450 550 450V505Z',
        'mini-ogee': 'M250 505V450Q290 450 315 435H485Q510 450 550 450V505Z'
      };
      const baseHeights = {
        straight: 70,
        rounded: 70,
        'big-radius': 70,
        'gentle-arch': 70,
        shouldered: 75,
        'wide-shoulder': 85,
        'standard-ogee': 110,
        'double-ogee': 80,
        'tall-ogee': 110,
        'cove-bead': 95,
        french: 95,
        'mini-ogee': 70
      };
      const shape = selectedBacksplashStyle()?.dataset.shape || 'straight';
      const pathD = paths[shape] || paths.straight;
      drawingBacksplash.setAttribute('d', pathD);
      const scaleX = geometry.widthPx / 300;
      const scaleY = geometry.backsplashHeightPx / (baseHeights[shape] || 70);
      drawingBacksplash.setAttribute('transform', [
        `translate(${round(geometry.frontLeft, 2)} ${round(geometry.frontBodyTop, 2)})`,
        `scale(${round(scaleX, 4)} ${round(scaleY, 4)})`,
        'translate(-250 -505)'
      ].join(' '));

      if (drawingBacksplashInner) {
        const hasOffset = backsplashOffset?.value === 'yes' && backsplash.value === 'Yes';
        setHidden(drawingBacksplashInner, !hasOffset);
        if (hasOffset) {
          drawingBacksplashInner.setAttribute('d', pathD);
          // Scale down inner line so it sits cleanly inside outer backsplash without overflow
          const insetX = Math.min(10, geometry.widthPx * 0.04);
          const insetY = Math.min(10, geometry.backsplashHeightPx * 0.18);
          const targetWidth = Math.max(20, geometry.widthPx - insetX * 2);
          const targetHeight = Math.max(10, geometry.backsplashHeightPx - insetY);
          const innerScaleX = targetWidth / 300;
          const innerScaleY = targetHeight / (baseHeights[shape] || 70);
          const innerLeft = geometry.frontLeft + insetX;
          const innerTop = geometry.frontBodyTop;
          drawingBacksplashInner.setAttribute('transform', [
            `translate(${round(innerLeft, 2)} ${round(innerTop, 2)})`,
            `scale(${round(innerScaleX, 4)} ${round(innerScaleY, 4)})`,
            'translate(-250 -505)'
          ].join(' '));
        }
      }
    }

    function updateDrawingGeometry() {
      const widthInches = clamp(inches(widthInput), 18, 80);
      const drawingScale = Math.min(9.5, 600 / widthInches);
      const depthInches = clamp(inches(depthInput), 12, 22);
      const heightInches = clamp(inches(heightInput), 6, 12);
      const backsplashInches = clamp(inches(backsplashInput), 3, 12);
      const widthPx = widthInches * drawingScale;
      const depthPx = depthInches * drawingScale;
      const bodyHeightPx = heightInches * drawingScale;
      const backsplashHeightPx = backsplashInches * drawingScale;
      const centerX = 400;

      const planTop = 105;
      const planLeft = centerX - widthPx / 2;
      const planRight = centerX + widthPx / 2;
      const planBottom = planTop + depthPx;
      const roundedCorners = cornerStyle?.value === 'rounded';
      const planCorner = roundedCorners ? Math.min(28, depthPx * .18, widthPx * .08) : 0;
      planBody?.setAttribute('d', roundedCorners
        ? `M${round(planLeft, 2)} ${planTop}H${round(planRight, 2)}V${round(planBottom - planCorner, 2)}Q${round(planRight, 2)} ${round(planBottom, 2)} ${round(planRight - planCorner, 2)} ${round(planBottom, 2)}H${round(planLeft + planCorner, 2)}Q${round(planLeft, 2)} ${round(planBottom, 2)} ${round(planLeft, 2)} ${round(planBottom - planCorner, 2)}Z`
        : `M${round(planLeft, 2)} ${planTop}H${round(planRight, 2)}V${round(planBottom, 2)}H${round(planLeft, 2)}Z`);

      const inset = Math.min(12, widthPx * .055, depthPx * .08);
      const innerLeft = planLeft + inset;
      const innerRight = planRight - inset;
      const innerTop = planTop + inset;
      const innerBottom = planBottom - inset;
      const innerCorner = roundedCorners ? Math.max(8, planCorner - inset / 2) : 0;
      planInner?.setAttribute('d', roundedCorners
        ? `M${round(innerLeft, 2)} ${round(innerTop, 2)}H${round(innerRight, 2)}V${round(innerBottom - innerCorner, 2)}Q${round(innerRight, 2)} ${round(innerBottom, 2)} ${round(innerRight - innerCorner, 2)} ${round(innerBottom, 2)}H${round(innerLeft + innerCorner, 2)}Q${round(innerLeft, 2)} ${round(innerBottom, 2)} ${round(innerLeft, 2)} ${round(innerBottom - innerCorner, 2)}Z`
        : `M${round(innerLeft, 2)} ${round(innerTop, 2)}H${round(innerRight, 2)}V${round(innerBottom, 2)}H${round(innerLeft, 2)}Z`);
      setHidden(planInner, surfaceOffset?.value !== 'yes');

      const requestedLeftShelf = inches(leftShelf) || 6;
      const requestedRightShelf = inches(rightShelf) || 6;
      const leftShelfPx = requestedLeftShelf * drawingScale;
      const rightShelfPx = requestedRightShelf * drawingScale;
      const bowlX = planLeft + leftShelfPx;
      const bowlWidth = Math.max(2 * drawingScale, widthPx - leftShelfPx - rightShelfPx);
      const bowlCenterX = bowlX + bowlWidth / 2;

      const isDeckFaucet = faucetLocation.value === 'deck';
      const minBackShelfInches = isDeckFaucet ? 5 : 2;
      const requestedBackShelf = Math.max(minBackShelfInches, inches(backShelf) || minBackShelfInches);
      const requestedFrontShelf = Math.max(1.5, inches(frontShelf) || 1.5);
      const backShelfPx = requestedBackShelf * drawingScale;
      const frontShelfPx = requestedFrontShelf * drawingScale;
      const bowlY = planTop + backShelfPx;
      const bowlHeight = Math.max(1 * drawingScale, depthPx - backShelfPx - frontShelfPx);
      const bowlCenterY = bowlY + bowlHeight / 2;

      setAttributes(drawingBowl, {
        x: bowlX,
        y: bowlY,
        width: bowlWidth,
        height: bowlHeight,
        rx: bowl.value === 'square' ? Math.min(7, bowlHeight * .12) : Math.min(bowlWidth, bowlHeight) * .46
      });

      // Drain is always centered in the bowl (both horizontal and vertical center)
      setAttributes(planDrain, { cx: bowlCenterX, cy: bowlCenterY, r: clamp(bowlHeight * .065, 4, 7) });

      const standardBackShelfInches = 5;
      const standardBackShelfPx = standardBackShelfInches * drawingScale;
      const faucetY = planTop + standardBackShelfPx / 2;
      const faucetSpreadInches = clamp(inches(faucetSpread) || 8, 2, 16);
      const faucetSpreadPx = Math.min(faucetSpreadInches * drawingScale, bowlWidth * .72);
      const faucetHoleCount = Number.parseInt(faucetHoles.value, 10);
      updateFaucetDrawing(drawingFaucet, planFaucetDimension, bowlCenterX, faucetY, isDeckFaucet, faucetHoleCount, faucetSpreadInches, faucetSpreadPx);

      // Back and Front Shelf dimension lines (safely positioned clear of all faucet holes with text on the left)
      const leftFaucetBound = (isDeckFaucet && faucetHoleCount > 1) ? (bowlCenterX - faucetSpreadPx / 2) : bowlCenterX;
      const dimX = Math.max(planLeft + 12, Math.min(bowlX - 14, leftFaucetBound - 40));
      const bowlBottom = bowlY + bowlHeight;
      const witnessRight = Math.max(dimX + 4, bowlX + 4);

      if (backShelfDimension) {
        const backLines = backShelfDimension.querySelectorAll('line');
        const backText = backShelfDimension.querySelector('text');
        setLine(backLines[0], dimX, planTop + 3, dimX, bowlY - 3);
        setLine(backLines[1], dimX - 4, planTop, dimX + 4, planTop);
        setLine(backLines[2], dimX - 4, bowlY, witnessRight, bowlY);
        setAttributes(backText, { x: dimX - 6, y: (planTop + bowlY) / 2 + 3 });
        backText.setAttribute('text-anchor', 'end');
        backText.textContent = `${displayValue(backShelf)}${unit === 'cm' ? ' cm' : '"'}`;
        setHidden(backText, backShelfPx < 4);
      }

      if (frontShelfDimension) {
        const frontLines = frontShelfDimension.querySelectorAll('line');
        const frontText = frontShelfDimension.querySelector('text');
        setLine(frontLines[0], dimX, bowlBottom + 3, dimX, planBottom - 3);
        setLine(frontLines[1], dimX - 4, bowlBottom, witnessRight, bowlBottom);
        setLine(frontLines[2], dimX - 4, planBottom, dimX + 4, planBottom);
        setAttributes(frontText, { x: dimX - 6, y: (bowlBottom + planBottom) / 2 + 3 });
        frontText.setAttribute('text-anchor', 'end');
        frontText.textContent = `${displayValue(frontShelf)}${unit === 'cm' ? ' cm' : '"'}`;
        setHidden(frontText, frontShelfPx < 4);
      }

      const shelfDimensionY = bowlY + bowlHeight * .56;
      const setShelfDimension = (group, startX, endX, label, shelfWidthPx) => {
        if (!group) return;
        const lines = group.querySelectorAll('line');
        const text = group.querySelector('text');
        const direction = endX >= startX ? 1 : -1;
        const lineStart = startX + direction * 4;
        const lineEnd = endX - direction * 4;
        setLine(lines[0], lineStart, shelfDimensionY, lineEnd, shelfDimensionY);
        setLine(lines[1], lineStart, shelfDimensionY - 4, lineStart, shelfDimensionY + 4);
        setLine(lines[2], lineEnd, shelfDimensionY - 4, lineEnd, shelfDimensionY + 4);
        setAttributes(text, { x: (startX + endX) / 2, y: shelfDimensionY - 7 });
        text.textContent = label;
        setHidden(text, shelfWidthPx < 34);
      };
      setShelfDimension(leftShelfDimension, planLeft, bowlX, `L ${displayValue(leftShelf)}${unit === 'cm' ? ' cm' : '\"'}`, leftShelfPx);
      setShelfDimension(rightShelfDimension, bowlX + bowlWidth, planRight, `R ${displayValue(rightShelf)}${unit === 'cm' ? ' cm' : '\"'}`, rightShelfPx);

      const widthLines = planWidthDimension?.querySelectorAll('line') || [];
      const widthText = planWidthDimension?.querySelector('text');
      const widthDimensionY = planBottom + 31;
      setLine(widthLines[0], planLeft, widthDimensionY, planRight, widthDimensionY);
      setLine(widthLines[1], planLeft, widthDimensionY - 8, planLeft, widthDimensionY + 8);
      setLine(widthLines[2], planRight, widthDimensionY - 8, planRight, widthDimensionY + 8);
      setAttributes(widthText, { x: centerX, y: widthDimensionY - 11 });

      const depthLines = planDepthDimension?.querySelectorAll('line') || [];
      const depthText = planDepthDimension?.querySelector('text');
      const depthDimensionX = planLeft - 24;
      setLine(depthLines[0], depthDimensionX, planTop, depthDimensionX, planBottom);
      setLine(depthLines[1], depthDimensionX - 8, planTop, depthDimensionX + 8, planTop);
      setLine(depthLines[2], depthDimensionX - 8, planBottom, depthDimensionX + 8, planBottom);
      setAttributes(depthText, { x: depthDimensionX - 22, y: planTop + depthPx / 2 + 4 });

      const frontBottom = 650;
      const frontLeft = planLeft;
      const frontRight = planRight;
      const frontBodyTop = frontBottom - bodyHeightPx;
      setAttributes(frontBody, { x: frontLeft, y: frontBodyTop, width: widthPx, height: bodyHeightPx, rx: roundedCorners ? Math.min(6, bodyHeightPx * .08) : 0 });

      const fluteRects = [...(previewFlutes?.querySelectorAll('rect') || [])];
      const fluteInset = Math.min(5, widthPx * .015);
      const flutePitch = (widthPx - fluteInset * 2) / Math.max(1, fluteRects.length);
      fluteRects.forEach((rect, index) => {
        const fluteWidth = Math.max(4, flutePitch * .68);
        setAttributes(rect, {
          x: frontLeft + fluteInset + index * flutePitch + (flutePitch - fluteWidth) / 2,
          y: frontBodyTop + 2,
          width: fluteWidth,
          height: Math.max(8, bodyHeightPx - 4),
          rx: Math.min(3, fluteWidth * .24)
        });
      });

      const frontLines = frontHeightDimension?.querySelectorAll('line') || [];
      const frontText = frontHeightDimension?.querySelector('text');
      const frontDimensionX = frontRight + 24;
      setLine(frontLines[0], frontDimensionX, frontBodyTop, frontDimensionX, frontBottom);
      setLine(frontLines[1], frontDimensionX - 8, frontBodyTop, frontDimensionX + 8, frontBodyTop);
      setLine(frontLines[2], frontDimensionX - 8, frontBottom, frontDimensionX + 8, frontBottom);
      setAttributes(frontText, { x: frontDimensionX + 28, y: frontBodyTop + bodyHeightPx / 2 + 4 });

      const backsplashLines = backsplashDimension?.querySelectorAll('line') || [];
      const backsplashText = backsplashDimension?.querySelector('text');
      const backsplashTop = frontBodyTop - backsplashHeightPx;
      setLine(backsplashLines[0], frontDimensionX, backsplashTop, frontDimensionX, frontBodyTop);
      setLine(backsplashLines[1], frontDimensionX - 8, backsplashTop, frontDimensionX + 8, backsplashTop);
      setAttributes(backsplashText, { x: frontDimensionX + 30, y: backsplashTop + backsplashHeightPx / 2 + 4 });
      updateBacksplashDrawing({ frontLeft, frontBodyTop, widthPx, backsplashHeightPx });
      updateFaucetDrawing(
        frontFaucet,
        frontFaucetDimension,
        bowlCenterX,
        frontBodyTop - backsplashHeightPx / 2,
        faucetLocation.value === 'backsplash' && backsplash.value === 'Yes',
        faucetHoleCount,
        faucetSpreadInches,
        faucetSpreadPx
      );

      const sideLeft = 252;
      const sideRight = sideLeft + depthPx;
      const sideBottom = 930;
      const sideBodyTop = sideBottom - bodyHeightPx;
      setLine(sideWall, sideLeft, 718, sideLeft, 1000);
      setAttributes(sideBacksplash, { x: sideLeft, y: sideBodyTop - backsplashHeightPx, width: Math.max(9, drawingScale * 1.1), height: backsplashHeightPx });
      sideBody?.setAttribute('d', `M${sideLeft} ${round(sideBodyTop, 2)}H${round(sideRight, 2)}V${sideBottom}H${sideLeft}Z`);

      const sideFluteRects = [...(sideFlutes?.querySelectorAll('rect') || [])];
      const sideFluteInset = Math.min(4, depthPx * .025);
      const sideFlutePitch = (depthPx - sideFluteInset * 2) / Math.max(1, sideFluteRects.length);
      sideFluteRects.forEach((rect, index) => {
        const fluteWidth = Math.max(3, sideFlutePitch * .7);
        setAttributes(rect, {
          x: sideLeft + sideFluteInset + index * sideFlutePitch + (sideFlutePitch - fluteWidth) / 2,
          y: sideBodyTop + 2,
          width: fluteWidth,
          height: Math.max(8, bodyHeightPx - 4),
          rx: Math.min(3, fluteWidth * .25)
        });
      });

      const sideLines = sideDepthDimension?.querySelectorAll('line') || [];
      const sideText = sideDepthDimension?.querySelector('text');
      const sideDimensionY = sideBottom + 34;
      setLine(sideLines[0], sideLeft, sideDimensionY, sideRight, sideDimensionY);
      setLine(sideLines[1], sideLeft, sideDimensionY - 8, sideLeft, sideDimensionY + 8);
      setLine(sideLines[2], sideRight, sideDimensionY - 8, sideRight, sideDimensionY + 8);
      setAttributes(sideText, { x: (sideLeft + sideRight) / 2, y: sideDimensionY - 10 });

      const noteTexts = sideNotes?.querySelectorAll('text') || [];
      const noteLine = sideNotes?.querySelector('line');
      const noteX = sideRight + 45;
      const noteY = Math.max(762, sideBodyTop - 32);
      noteTexts.forEach((text, index) => setAttributes(text, { x: noteX, y: noteY + index * 24 }));
      setLine(noteLine, sideRight, sideBodyTop + bodyHeightPx * .22, noteX - 14, noteY + 10);

      const technicalDrawing = root.querySelector('[data-technical-drawing]');
      technicalDrawing?.setAttribute('aria-label', `Technical drawing of a ${round(widthInches, 1)} by ${round(depthInches, 1)} by ${round(heightInches, 1)} inch marble sink with ${round(requestedLeftShelf, 1)} inch left and ${round(requestedRightShelf, 1)} inch right shelves`);
    }

    function toggleFaucetControls() {
      const location = faucetLocation.value;
      const holes = Number.parseInt(faucetHoles.value, 10);
      faucetSettings.hidden = location === 'none';
      spreadControl.hidden = location === 'none' || holes < 2;

      const spreadVal = val(faucetSpread);
      const isUniversal = (unit === 'in' && Math.abs(spreadVal - 8) < 0.1) || (unit === 'cm' && Math.round(spreadVal) === 20);
      if (resetUniversalBtn && universalBtnText) {
        if (isUniversal) {
          resetUniversalBtn.classList.add('is-active');
          universalBtnText.textContent = `✓ Universal (${unit === 'cm' ? '20 cm' : '8"'})`;
          resetUniversalBtn.title = 'Universal spread is currently selected';
        } else {
          resetUniversalBtn.classList.remove('is-active');
          universalBtnText.textContent = '↺ Reset to Universal';
          resetUniversalBtn.title = `Set to Universal Spread (${unit === 'cm' ? '20 cm' : '8"'})`;
        }
      }

      const isDeck = location === 'deck';
      const minCm = isDeck ? 13 : 5;
      const minIn = isDeck ? 5 : 2;
      if (backShelf) {
        backShelf.dataset.minIn = String(minIn);
        if (unit === 'cm') {
          backShelf.min = minCm;
          if (val(backShelf) < minCm) {
            backShelf.value = minCm;
          }
        } else {
          backShelf.min = minIn;
          if (val(backShelf) < minIn) {
            backShelf.value = minIn;
          }
        }
      }
    }

    function calculateEstimate(hasBacksplash) {
      const volume = (inches(widthInput) * 2.54) * (inches(depthInput) * 2.54) * (inches(heightInput) * 2.54);
      let estimate = 0;
      if (volume <= 18000) estimate = volume * (1180 / 18000);
      else if (volume <= 48000) estimate = volume * (1650 / 48000);
      else if (volume <= 60800) estimate = volume * (2080 / 60800);
      else if (volume <= 80000) estimate = volume * (2960 / 80000);
      else estimate = volume * (4000 / 120000);
      return Math.round(Math.max(1390, estimate) + (hasBacksplash ? 240 : 0));
    }

    function updateSummaryField() {
      const material = checked('contact[Material]')?.value || 'Not selected';
      const backsplashStyle = selectedBacksplashStyle()?.value || 'Straight';
      const summary = [
        `Material: ${material}`,
        `Dimensions: ${widthInput.value} × ${depthInput.value} × ${heightInput.value} ${unit}`,
        `Backsplash: ${backsplash.value}${backsplash.value === 'Yes' ? `, ${backsplashStyle}, ${backsplashInput.value} ${unit} high` : ''}`,
        `Bowl: ${bowl.options[bowl.selectedIndex].text}`,
        `Faucet: ${faucetLocation.options[faucetLocation.selectedIndex].text}, ${faucetHoles.options[faucetHoles.selectedIndex].text}`,
        `Front: ${finish.options[finish.selectedIndex].text}`,
        `Estimated price: ${root.querySelector('[data-estimate]').textContent}`
      ].join(' | ');
      root.querySelector('[data-summary-field]').value = summary;
      return summary;
    }

    function buildCartProperties() {
      const material = checked('contact[Material]')?.value || 'Not selected';
      const backsplashStyle = selectedBacksplashStyle()?.value || 'Straight';
      const detail = (name) => root.querySelector(`[data-detail="${name}"]`);
      const selection = (select) => select?.options[select.selectedIndex]?.text || '';
      const hasBacksplash = backsplash.value === 'Yes';
      const hasFaucet = faucetLocation.value !== 'none';
      return {
        Material: material,
        Dimensions: `${displayValue(widthInput)} × ${displayValue(depthInput)} × ${displayValue(heightInput)} ${unit}`,
        Backsplash: hasBacksplash ? `${backsplashStyle}, ${displayValue(backsplashInput)} ${unit} high` : 'None',
        'Backsplash Offset': hasBacksplash ? (backsplashOffset?.value === 'yes' ? 'Yes (1" Offset)' : 'None (Flush)') : 'Not applicable',
        'Inner Bowl': selection(bowl),
        'Faucet Location': selection(faucetLocation),
        'Faucet Holes': hasFaucet ? selection(faucetHoles) : 'None',
        'Faucet Spread': hasFaucet && Number.parseInt(faucetHoles.value, 10) > 1 ? `${displayValue(faucetSpread)} ${unit}` : 'Not applicable',
        'Left Shelf': `${displayValue(leftShelf)} ${unit}`,
        'Right Shelf': `${displayValue(rightShelf)} ${unit}`,
        'Back Shelf': `${displayValue(backShelf)} ${unit}`,
        'Front Shelf': `${displayValue(frontShelf)} ${unit}`,
        'Front Corner': selection(detail('corner')),
        Fluting: selection(finish),
        'Top Surface': selection(detail('offset')),
        Installation: 'Wall mounted',
        'Configured Price': money.format(currentPrice),
        '_Configuration ID': `NCM-${Date.now()}`
      };
    }

    async function addToCart(event) {
      event.preventDefault();
      if (inches(widthInput) > 60) {
        if (whatsappOrderBtn && whatsappOrderBtn.href) {
          window.open(whatsappOrderBtn.href, '_blank');
        }
        return;
      }
      if (!cartButton || cartButton.disabled) return;
      cartButton.disabled = true;
      cartButton.textContent = 'ADDING…';
      cartMessage.hidden = true;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(configuratorVariant.value),
              quantity: currentPrice,
              properties: buildCartProperties()
            }]
          })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'The configuration could not be added to the bag.');
        }
        cartButton.textContent = 'ADDED';
        cartMessage.textContent = 'Your custom sink has been added to the bag.';
        cartMessage.classList.remove('is-error');
        cartMessage.hidden = false;
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        cartButton.disabled = false;
        cartButton.textContent = 'ADD TO CART';
        cartMessage.textContent = error.message;
        cartMessage.classList.add('is-error');
        cartMessage.hidden = false;
      }
    }

    function enforceShelfConstraints() {
      const depthVal = val(depthInput);
      const isDeck = faucetLocation.value === 'deck';
      const minBackShelf = unit === 'cm' ? (isDeck ? 13 : 5) : (isDeck ? 5 : 2);
      const minFrontShelf = unit === 'cm' ? 4 : 1.5;
      const minBowlDepth = unit === 'cm' ? 2.5 : 1.0;

      if (backShelf && frontShelf) {
        if (val(frontShelf) < minFrontShelf) {
          frontShelf.value = minFrontShelf;
        }

        const currentFront = Math.max(minFrontShelf, val(frontShelf) || minFrontShelf);
        const maxBack = Math.max(minBackShelf, round(depthVal - currentFront - minBowlDepth, 1));
        backShelf.min = minBackShelf;
        backShelf.max = maxBack;
        backShelf.step = unit === 'cm' ? 1 : 0.5;
        if (val(backShelf) > maxBack) {
          backShelf.value = maxBack;
        } else if (val(backShelf) < minBackShelf) {
          backShelf.value = minBackShelf;
        }

        const currentBack = Math.max(minBackShelf, val(backShelf) || minBackShelf);
        const maxFront = Math.max(minFrontShelf, round(depthVal - currentBack - minBowlDepth, 1));
        frontShelf.min = minFrontShelf;
        frontShelf.max = maxFront;
        frontShelf.step = unit === 'cm' ? 1 : 0.5;
        if (val(frontShelf) > maxFront) {
          frontShelf.value = maxFront;
        } else if (val(frontShelf) < minFrontShelf) {
          frontShelf.value = minFrontShelf;
        }
      }

      const widthVal = val(widthInput);
      const minLeftShelf = unit === 'cm' ? 3 : 1.0;
      const minRightShelf = unit === 'cm' ? 3 : 1.0;
      const minBowlWidth = unit === 'cm' ? 5 : 2.0;

      if (leftShelf && rightShelf) {
        if (val(leftShelf) < minLeftShelf) {
          leftShelf.value = minLeftShelf;
        }
        if (val(rightShelf) < minRightShelf) {
          rightShelf.value = minRightShelf;
        }

        const currentRight = Math.max(minRightShelf, val(rightShelf) || minRightShelf);
        const maxLeft = Math.max(minLeftShelf, round(widthVal - currentRight - minBowlWidth, 1));
        leftShelf.min = minLeftShelf;
        leftShelf.max = maxLeft;
        leftShelf.step = unit === 'cm' ? 1 : 0.5;
        if (val(leftShelf) > maxLeft) {
          leftShelf.value = maxLeft;
        } else if (val(leftShelf) < minLeftShelf) {
          leftShelf.value = minLeftShelf;
        }

        const currentLeft = Math.max(minLeftShelf, val(leftShelf) || minLeftShelf);
        const maxRight = Math.max(minRightShelf, round(widthVal - currentLeft - minBowlWidth, 1));
        rightShelf.min = minRightShelf;
        rightShelf.max = maxRight;
        rightShelf.step = unit === 'cm' ? 1 : 0.5;
        if (val(rightShelf) > maxRight) {
          rightShelf.value = maxRight;
        } else if (val(rightShelf) < minRightShelf) {
          rightShelf.value = minRightShelf;
        }
      }
    }

    function updatePreview() {
      const material = checked('contact[Material]');
      const materialHandle = material?.closest('[data-material-choice]')?.dataset.materialChoice || 'calacatta-viola';
      [...preview.classList].filter((name) => name.startsWith('stone-')).forEach((name) => preview.classList.remove(name));
      preview.classList.add(`stone-${materialHandle}`);

      if (stonePatternImage && stoneUrlMap[materialHandle]) {
        stonePatternImage.setAttribute('href', stoneUrlMap[materialHandle]);
      }

      setText('[data-summary-material]', material?.value || 'Not selected');
      const summarySwatch = root.querySelector('[data-summary-swatch]');
      if (summarySwatch) {
        [...summarySwatch.classList].filter((name) => name.startsWith('stone-')).forEach((name) => summarySwatch.classList.remove(name));
        summarySwatch.classList.add(`stone-${materialHandle}`);
      }
      setText('[data-summary-dimensions]', `${displayValue(widthInput)} × ${displayValue(depthInput)} × ${displayValue(heightInput)} ${unit}`);
      setText('[data-summary-installation]', 'Wall mounted');
      setText('[data-summary-finish]', finish.options[finish.selectedIndex].text);
      setText('[data-drawing-width]', `${displayValue(widthInput)}${unit === 'in' ? '"' : ' cm'}`);
      setText('[data-drawing-depth]', `${displayValue(depthInput)}${unit === 'in' ? '"' : ' cm'}`);
      setText('[data-drawing-side-depth]', `${displayValue(depthInput)}${unit === 'in' ? '"' : ' cm'}`);
      setText('[data-drawing-height]', `${displayValue(heightInput)}${unit === 'in' ? '"' : ' cm'}`);
      setText('[data-drawing-backsplash-height]', `${displayValue(backsplashInput)}${unit === 'in' ? '"' : ' cm'}`);

      const hasBacksplash = backsplash.value === 'Yes';
      setHidden(backsplashOptions, !hasBacksplash);
      previewBacksplashes.forEach((node) => setHidden(node, !hasBacksplash));
      setHidden(root.querySelector('[data-backsplash-dimension]'), !hasBacksplash);
      setHidden(drawingBacksplash, !hasBacksplash);
      setHidden(previewFlutes, finish.value === 'none');
      setHidden(sideFlutes, finish.value !== 'three');
      toggleFaucetControls();
      enforceShelfConstraints();
      updateDrawingGeometry();
      currentPrice = calculateEstimate(hasBacksplash);
      root.querySelector('[data-estimate]').textContent = money.format(currentPrice);
      updateSummaryField();

      const currentWidthIn = inches(widthInput);
      const isOversized = currentWidthIn > 60;
      if (cartButton) setHidden(cartButton, isOversized);
      if (cartSubtext) setHidden(cartSubtext, isOversized);
      if (whatsappOrderBtn) {
        setHidden(whatsappOrderBtn, !isOversized);
        if (isOversized) {
          const matName = material?.value || 'Calacatta Viola';
          const dims = `${displayValue(widthInput)} × ${displayValue(depthInput)} × ${displayValue(heightInput)} ${unit}`;
          const bSplash = hasBacksplash ? `${selectedBacksplashStyle()?.value || 'Straight'}, ${displayValue(backsplashInput)} ${unit}` : 'None';
          const bShape = bowl.options[bowl.selectedIndex]?.text || '';
          const fLoc = faucetLocation.options[faucetLocation.selectedIndex]?.text || '';
          const fHoles = faucetHoles.options[faucetHoles.selectedIndex]?.text || '';
          const msg = encodeURIComponent(
            `Hello Natural Custom Marble,\n\nI would like to place an order / inquire about a custom oversized marble sink (60"+):\n` +
            `• Material: ${matName}\n` +
            `• Dimensions: ${dims}\n` +
            `• Backsplash: ${bSplash}\n` +
            `• Inner Bowl: ${bShape}\n` +
            `• Faucet: ${fLoc} (${fHoles})\n` +
            `• Estimated Price: ${money.format(currentPrice)}\n\n` +
            `Please share available marble slabs and freight crating timeline.`
          );
          whatsappOrderBtn.href = `https://wa.me/905395805957?text=${msg}`;
        }
      }
      if (oversizeNotice) setHidden(oversizeNotice, !isOversized);
    }

    function updateDimensionConstraints(input) {
      const dim = input.dataset.dimension;
      if (dim === 'back-shelf' || dim === 'front-shelf' || dim === 'left-shelf' || dim === 'right-shelf') {
        enforceShelfConstraints();
        return;
      } else if (dim === 'faucet-spread') {
        if (unit === 'cm') {
          input.min = Math.round(Number(input.dataset.minIn) * 2.54);
          input.max = Math.round(Number(input.dataset.maxIn) * 2.54);
          input.step = 1;
        } else {
          input.min = Number(input.dataset.minIn);
          input.max = Number(input.dataset.maxIn);
          input.step = Number(input.dataset.stepIn) || 0.5;
        }
      } else if (unit === 'cm') {
        input.min = Math.round(Number(input.dataset.minIn) * 2.54);
        input.max = Math.round(Number(input.dataset.maxIn) * 2.54);
        input.step = 1;
      } else {
        input.min = Number(input.dataset.minIn);
        input.max = Number(input.dataset.maxIn);
        input.step = Number(input.dataset.stepIn) || 1;
      }
      const range = root.querySelector(`[data-range-for="${input.dataset.dimension}"]`);
      if (range) {
        range.min = input.min;
        range.max = input.max;
        range.step = input.step;
        range.value = input.value;
      }
    }

    unitButtons.forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.unit === unit) return;
      const toCm = button.dataset.unit === 'cm';
      unit = button.dataset.unit;
      dimensions.forEach((input) => {
        const dim = input.dataset.dimension;
        if (dim === 'faucet-spread') {
          if (toCm) {
            input.value = Math.round(val(input) * 2.54) === 20 ? 20 : Math.round(val(input) * 2.54);
          } else {
            input.value = Math.round(val(input)) === 20 ? 8 : round(val(input) / 2.54, 1);
          }
        } else if (dim === 'back-shelf') {
          const isDeck = faucetLocation.value === 'deck';
          if (toCm) {
            input.value = Math.max(isDeck ? 13 : 5, Math.round(val(input) * 2.54));
          } else {
            input.value = Math.max(isDeck ? 5 : 2, Math.round(val(input) / 2.54 * 2) / 2);
          }
        } else {
          input.value = toCm ? Math.round(val(input) * 2.54) : round(val(input) / 2.54, 1);
        }
        updateDimensionConstraints(input);
      });
      unitButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      root.querySelectorAll('[data-unit-label]').forEach((label) => label.textContent = unit);
      updatePreview();
    }));

    rangeInputs.forEach((range) => {
      const number = root.querySelector(`[data-dimension="${range.dataset.rangeFor}"]`);
      range.addEventListener('input', () => { number.value = range.value; updatePreview(); });
      number.addEventListener('input', () => { range.value = number.value; updatePreview(); });
    });

    [...stoneChoices, ...backsplashStyles].forEach((input) => input.addEventListener('input', updatePreview));
    [backsplash, bowl, finish, faucetLocation, faucetHoles, ...root.querySelectorAll('[data-detail]')].forEach((input) => input.addEventListener('change', updatePreview));
    root.querySelectorAll('input[data-detail]').forEach((input) => input.addEventListener('input', updatePreview));

    resetUniversalBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!faucetSpread) return;
      faucetSpread.value = unit === 'cm' ? 20 : 8;
      updatePreview();
    });

    printButton?.addEventListener('click', () => window.print());
    form.addEventListener('submit', addToCart);
    setText('[data-drawing-date]', new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date()));
    updatePreview();
  });
})();
